import { z } from 'zod';

const blankToNull = (value: unknown) => typeof value === 'string' && !value.trim() ? null : value;
const text = (max = 300) => z.preprocess(blankToNull, z.string().trim().min(1).max(max).nullable()).optional();
const decimal = z.preprocess(blankToNull, z.string().regex(/^(?:0|[1-9]\d{0,17})(?:\.\d{1,6})?$/).nullable()).optional();
const count = z.preprocess(blankToNull, z.string().regex(/^(?:0|[1-9]\d{0,5})$/).nullable()).optional();
const date = z.preprocess(blankToNull, z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine(value => {
  const parsed = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}, 'Must be a valid YYYY-MM-DD date.').nullable()).optional();

/** Optional additions keep existing trade revisions and document snapshots readable. */
export const transportHeaderShape = {
  transportDate: date, placeOfIssue: text(), placeOfDelivery: text(), finalDestination: text(),
  originals: count, blServiceType: text(100), totalContainers: count,
  awbNumber: text(100), departureAirport: text(), destinationAirport: text(), flightNumber: text(100), flightDate: date,
  declaredValueCarriage: text(), declaredValueCustoms: text(), handlingInformation: text(2000),
  weightChargeCode: text(100), weightPrepaid: decimal, weightCollect: decimal,
  otherChargeCode: text(100), otherPrepaid: decimal, otherCollect: decimal,
  taxChargeCode: text(100), taxPrepaid: decimal, taxCollect: decimal,
  voyageType: text(100), carrierName: text(), masterName: text(), preparedBy: text(), manifestDeclaration: text(2000),
  ourReference: text(), courierNumber: text(), dispatchDate: date,
  bookingNumber: text(), forwarder: text(1000), blConsignee: text(1000), blNotifyParty: text(1000), releaseClause: text(2000), issuerPhone: text(100),
};
export const transportItemShape = {
  sealNumber: text(200), containerType: text(100), chargeableWeight: text(200),
  billOfLadingNumber: text(200), shipper: text(1000), consignee: text(1000),
};
export const transportTermNames = Object.keys(transportHeaderShape) as (keyof typeof transportHeaderShape)[];
export const transportItemNames = Object.keys(transportItemShape) as (keyof typeof transportItemShape)[];
export type TransportTerms = z.output<z.ZodObject<typeof transportHeaderShape>>;
export type TransportItem = z.output<z.ZodObject<typeof transportItemShape>>;
